module.exports = "/_next/static/images/23-1-d274419d73d6a0ae80150f946bd69fb3.svg";